import Vue from 'vue'
import Vuex from 'vuex'
import config from './modules/config'
import login from './modules/login'
import cart from './modules/cart'
import reservation from './modules/reservation'
import timeslots from './modules/timeslots'
import stores from './modules/stores'
import deliveryAddress from './modules/deliveryAddress'
import profile from './modules/profile'
import shoppingList from './modules/shoppingList'
import orderHistory from './modules/orderHistory'
import orderAddOns from './modules/orderAddOns'
import errors from './modules/errors'
import loading from './modules/loading'
import products from './modules/products'
import geoStates from './modules/geoStates'
import exoPlugin from './plugins/exo';
import versionedContent from './modules/versionedContent';

Vue.use(Vuex)

// Uncomment if debugging Vuex in the Vue Devtools.
// Vue.config.devtools = true

export default new Vuex.Store({
  modules: {
    config,
    login,
    cart,
    reservation,
    timeslots,
    stores,
    deliveryAddress,
    profile,
    shoppingList,
    orderHistory,
    orderAddOns,
    errors,
    loading,
    products,
    versionedContent,
    geoStates
  },
  plugins: [exoPlugin],
  strict: process.env.NODE_ENV !== "production"
});
